import { render, staticRenderFns } from "./Phrase.vue?vue&type=template&id=1d639deb&"
import script from "./Phrase.vue?vue&type=script&lang=js&"
export * from "./Phrase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Phrase.vue"
export default component.exports